import React from "react";
import { useState } from 'react'
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import arrowGif from '../../../assets/gifs/arrow.gif'
import "../modal.css";
import './SpeechBubbleModal.css'
import proPic from '../../../assets/Propic2.png'
const SpeechBubbleModal = (props) => {
    const [show, setShow] = useState(props.show)
  // const [show, setShow] = useState(false);
  const hideIT =() => {
      // console.log('hiding it')
    //   props.onHide()
      setShow(false)
  }

  return (
    <>
      <div className={`${props.show ? "bubble" : "bubble-hidden"}`}>
        <div className="bubble-content-wrapper">
          <div className="avater-wrapper" style={{ position: "relative" }}>
            <img className="propic" src={proPic} alt="billBoard_garden" />
            <svg
              class="blob"
              viewBox="0 0 500 500"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* <defs>
              <pattern id="imgpattern" x="0" y="0" width="1" height="1">
                <image
                  width="120"
                  height="250"
                  //   src={proPic}
                  href="Propic2.png"
                />
              </pattern>
            </defs> */}
              <g transform="translate(250,250)">
                <path
                  d="M120,-157.6C152.7,-141.5,174.3,-102.6,194.8,-58.8C215.3,-14.9,234.6,33.8,228.4,80.8C222.2,127.8,190.4,173.1,148.1,184C105.8,195,52.9,171.5,-2.4,174.8C-57.8,178.2,-115.6,208.4,-137.5,190.9C-159.3,173.3,-145.3,108,-153,56.3C-160.7,4.6,-190.2,-33.4,-178.3,-54.2C-166.4,-75.1,-113.2,-78.8,-76.6,-93.6C-40,-108.3,-20,-134.2,11.9,-150.5C43.7,-166.8,87.4,-173.6,120,-157.6Z"
                  fill="red"
                />
              </g>
            </svg>
          </div>
          <div className="bubble-speech-wrapper">
            {/* <div style={{ width: "50%" }}></div> */}

            <p>
              <strong>
                <span>Hello! My name is Rakib.</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>Welcome to my world!</span>
              </strong>
              <br />I am so glad that you have found it. If you are new here then
              please see the <strong>Instruction </strong>
              first.
            </p>
          </div>
        </div>
        <button className="bubble-btn" onClick={props.onHide}>
          <span>OK</span>
        </button>
        <img
          src={arrowGif}
          alt="billBoard_garden"
          className="arrow-to-instruction"
        //   style={{ width: "100px", height: "50px" }}
        />
      </div>
    </>
  );
};

export default SpeechBubbleModal;


